var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c("div", { staticClass: "row position-relative" }, [
              _c(
                "div",
                { staticClass: "col-12 col-lg-7 mt-0 mt-lg-2" },
                [
                  _c("item-image-carousel", {
                    ref: "itemImageCarousel",
                    attrs: {
                      "item-id": _vm.itemId,
                      "image-urls-data":
                        _vm.currentVariation.images.variation.length > 0
                          ? _vm.currentVariation.images.variation
                          : _vm.currentVariation.images.all.slice(0, 5),
                      name: _vm.itemName,
                      "multi-language": {
                        ProductBackgroundVariations:
                          _vm.multiLanguage.ProductBackgroundVariations,
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-lg-5 pl-3 pl-lg-0" },
                [
                  _vm._t("item-reviews"),
                  _vm._v(" "),
                  _c("h1", { staticClass: "h1 title mt-2 mb-3" }, [
                    _vm._v(_vm._s(_vm.itemName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "price-container d-flex justify-content-between w-100 position-relative my-3 align-items-center",
                    },
                    [
                      _c("div", { staticClass: "price price-gross-net" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "actual-price-data d-flex align-items-center",
                          },
                          [
                            _c("span", { staticClass: "actual-price" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.multiLanguage.ProductShopPrice) +
                                  ":\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("del", { staticClass: "discounted-price" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      (_vm.isNet
                                        ? _vm.currentVariation.prices.rrp.data
                                            .unitPriceNet
                                        : _vm.currentVariation.prices.rrp.data
                                            .unitPrice) +
                                        _vm.variationPropertySurcharge
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.prices.default.categoryDiscount
                          .amount > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "discounted-price-data d-flex align-items-center",
                              },
                              [
                                _c(
                                  "del",
                                  {
                                    staticClass:
                                      "discounted-price text-primary",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            (_vm.isNet
                                              ? _vm.variationGraduatedPrice.data
                                                  .unitPriceNet
                                              : _vm.variationGraduatedPrice.data
                                                  .unitPrice) +
                                              _vm.variationPropertySurcharge +
                                              _vm.currentVariation.prices
                                                .default.categoryDiscount.amount
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "offer" }, [
                                  _vm._v(
                                    "\n                -" +
                                      _vm._s(
                                        _vm.currentVariation.prices.default
                                          .categoryDiscount.percent
                                      ) +
                                      "% " +
                                      _vm._s(_vm.multiLanguage.ProductExtra) +
                                      "\n              "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "total-price-data d-flex align-items-center",
                          },
                          [
                            _c("span", { staticClass: "total-price" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      (_vm.isNet
                                        ? _vm.variationGraduatedPrice.data
                                            .unitPriceNet
                                        : _vm.variationGraduatedPrice.data
                                            .unitPrice) +
                                        _vm.variationPropertySurcharge
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "item-vat" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.isNet
                                      ? _vm.multiLanguage.ProductIncludingNet
                                      : ["£", "CHF", "NOK", "US$"].includes(
                                          _vm.currency
                                        )
                                      ? _vm.multiLanguage.ProductExcludingVat
                                      : _vm.multiLanguage.ProductIncludingVat
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "icons d-flex justify-content-center align-items-center",
                        },
                        [
                          _c("add-to-wish-list", {
                            attrs: {
                              "variation-id": _vm.currentVariation.variation.id,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("other-forms", {
                    attrs: {
                      "item-id": _vm.itemId,
                      "multi-language": {
                        ProductOtherForms: _vm.multiLanguage.ProductOtherForms,
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("variation-select", {
                    attrs: {
                      "item-id": _vm.itemId,
                      "multi-language": {
                        VariationSelectSize:
                          _vm.multiLanguage.VariationSelectSize,
                        ShopBySizes: _vm.multiLanguage.ShopBySizes,
                        ProductInstock: _vm.multiLanguage.ProductInstock,
                        ProductOutOfStock: _vm.multiLanguage.ProductOutOfStock,
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.currentVariation.variation.bundleType === "bundle"
                    ? _c("item-bundle", {
                        attrs: {
                          "bundle-type":
                            _vm.currentVariation.variation.bundleType,
                          "bundle-components":
                            _vm.currentVariation.bundleComponents,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.language == "de" &&
                  _vm.currentVariation.filter.isSalable &&
                  _vm.variationGroupedProperties.length
                    ? _c("div", [_c("order-property-list")], 1)
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "my-3 text-center",
                      attrs: { id: "single-item-promo-bar" },
                    },
                    [_vm._t("item-code")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "add-to-cart",
                      attrs: { id: "addToCartButton" },
                    },
                    [
                      _c("add-to-basket", {
                        attrs: {
                          "show-buy-button": true,
                          "variation-id": _vm.currentVariation.variation.id,
                          "is-salable":
                            !!_vm.currentVariation.filter &&
                            _vm.currentVariation.filter.isSalable,
                          "has-children":
                            !!_vm.currentVariation.filter &&
                            _vm.currentVariation.filter.hasActiveChildren,
                          "interval-quantity":
                            _vm.currentVariation.variation
                              .intervalOrderQuantity || 1,
                          "minimum-quantity":
                            _vm.currentVariation.variation.minimumOrderQuantity,
                          "maximum-quantity":
                            !!_vm.currentVariation.variation
                              .maximumOrderQuantity &&
                            _vm.currentVariation.variation
                              .maximumOrderQuantity > 0
                              ? _vm.currentVariation.variation
                                  .maximumOrderQuantity
                              : null,
                          "order-properties":
                            _vm.currentVariation.properties.filter((prop) => {
                              return prop.property.isOderProperty
                            }),
                          "has-order-properties":
                            _vm.currentVariation.hasOrderProperties,
                          "has-required-order-property":
                            _vm.currentVariation.hasRequiredOrderProperty,
                          "use-large-scale": false,
                          "show-quantity": true,
                          "item-url": _vm._f("itemURL")(_vm.currentVariation),
                          "is-variation-selected":
                            _vm.isVariationSelected &&
                            _vm.currentVariation.filter.isSalable,
                          "has-price": _vm._f("hasItemDefaultPrice")(
                            _vm.currentVariation
                          ),
                          "multi-language": {
                            ProductBuyNow: _vm.multiLanguage.ProductBuyNow,
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("availability-request", {
                    attrs: {
                      "multi-language": {
                        ContactEmail: _vm.multiLanguage.ContactEmail,
                        ContactEmailPlaceholder:
                          _vm.multiLanguage.ContactEmailPlaceholder,
                        ContactNumber: _vm.multiLanguage.ContactNumber,
                        ContactNumberPlaceholder:
                          _vm.multiLanguage.ContactNumberPlaceholder,
                        AvailabilityTitle: _vm.multiLanguage.AvailabilityTitle,
                        AvailabilityText: _vm.multiLanguage.AvailabilityText,
                        AvailabilityButton:
                          _vm.multiLanguage.AvailabilityButton,
                        EmailFieldRequired:
                          _vm.multiLanguage.EmailFieldRequired,
                        PhoneNumberFieldRequired:
                          _vm.multiLanguage.PhoneNumberFieldRequired,
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("graduated-prices"),
                  _vm._v(" "),
                  _c("div", { staticClass: "single-item-info-card my-3" }, [
                    _c(
                      "ul",
                      { staticClass: "list-group list-group-flush" },
                      [
                        _c(
                          "li",
                          {
                            staticClass:
                              "list-group-item d-flex align-items-center",
                          },
                          [
                            _vm._t("item-availability-delivery"),
                            _vm._v(" "),
                            _vm.availability.names &&
                            _vm.availability.names.name
                              ? _c("span", [
                                  _vm._v(
                                    "\n                : " +
                                      _vm._s(_vm.availability.names.name) +
                                      "\n              "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass:
                              "list-group-item d-flex align-items-center justify-content-between flex-wrap",
                          },
                          [_vm._t("item-availability-shipping")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.guaranteeProduct
                          ? _vm._t("item-availability-guarantee")
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("item-availability-return"),
                        _vm._v(" "),
                        _vm._t("item-availability-direct"),
                        _vm._v(" "),
                        _vm.certificateOfAuthenticity &&
                        _vm.certificateOfAuthenticity.length > 0
                          ? _vm._t("item-certificate-authenticity")
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "my-4 item-details-container",
                attrs: { id: "item-details" },
              },
              [
                _c("div", { staticClass: "accordion-item" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "accordion-title d-block w-100 position-relative text-left cursor-pointer py-3",
                      attrs: {
                        id: "accordionDetails",
                        "data-toggle": "collapse",
                        "data-target": "#collapseDetails",
                        "aria-expanded": "true",
                        "aria-controls": "collapseDetails",
                      },
                    },
                    [
                      _c("p", { staticClass: "h4" }, [
                        _vm._v(_vm._s(_vm.multiLanguage.ProductDetailsTitle)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse show",
                      attrs: {
                        id: "collapseDetails",
                        "aria-labelledby": "accordionDetails",
                      },
                    },
                    [
                      _c("div", { staticClass: "row item-details py-3" }, [
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            { staticClass: "my-2" },
                            [
                              _c("p", { staticClass: "h5 mb-2" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.multiLanguage.ProductId) +
                                    "\n                  " +
                                    _vm._s(_vm.currentVariation.variation.id) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._t("item-note"),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "my-4" }, [
                            _c("p", { staticClass: "h5 mb-2" }, [
                              _vm._v(_vm._s(_vm.multiLanguage.ProductDetails)),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.currentVariation.texts.shortDescription
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "my-4" }, [
                            _c("p", { staticClass: "h5 mb-2" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.multiLanguage.ProductMoreInformation
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.filteredPropertiesList,
                                function (item) {
                                  return _c("li", { key: item.id }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.values.value) +
                                        "\n                  "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-lg-6 item-detail-row flex-wrap px-3",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mb-4 col-12 col-md-6 col-lg-12 px-0",
                              },
                              [
                                _c("p", { staticClass: "h5 mb-2" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.multiLanguage.ProductMaterialQuality
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.filteredMaterialList,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "d-flex materials-list",
                                      },
                                      [
                                        _c("p", { staticClass: "w-50" }, [
                                          _vm._v(
                                            _vm._s(
                                              item.names ? item.names.name : ""
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        item.id === 345 ||
                                        item.id === 348 ||
                                        item.id === 678
                                          ? _c(
                                              "div",
                                              { staticClass: "w-50 d-flex" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.values.value)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                item.values.description
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-feature position-relative cursor-pointer ml-2",
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              viewBox:
                                                                "0 0 50 50",
                                                              width: "16",
                                                              height: "16",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "feature d-none",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  item.values
                                                                    .description
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.names &&
                                                item.names.description &&
                                                _vm.isWool(
                                                  item.id,
                                                  item.values.value
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-feature position-relative cursor-pointer ml-2",
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              viewBox:
                                                                "0 0 50 50",
                                                              width: "16",
                                                              height: "16",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "feature d-none",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  item.names
                                                                    .description
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _c(
                                              "p",
                                              { staticClass: "w-50 d-flex" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.values.value)
                                                ),
                                              ]
                                            ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mb-4 col-12 col-md-6 col-lg-12 px-0",
                              },
                              [
                                _c("p", { staticClass: "h5 mb-2" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.multiLanguage.ProductMeasureWeight
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.filteredDimensionList,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass:
                                          "d-flex my-1 materials-list",
                                      },
                                      [
                                        _c("p", { staticClass: "w-50" }, [
                                          _vm._v(
                                            _vm._s(
                                              item.names ? item.names.name : ""
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        item.id == 659
                                          ? _c(
                                              "div",
                                              { staticClass: "w-50 d-flex" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.values.value)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                item.values.description
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-feature position-relative cursor-pointer ml-2",
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              viewBox:
                                                                "0 0 50 50",
                                                              width: "16",
                                                              height: "16",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "feature d-none",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  item.values
                                                                    .description
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : item.id === 657
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "w-50 d-flex align-items-center flex-wrap",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: { for: "dimension" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.initialMeasure ===
                                                            "cm"
                                                            ? item.values.value
                                                            : _vm.currentMeasure
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.initialMeasure,
                                                        expression:
                                                          "initialMeasure",
                                                      },
                                                    ],
                                                    attrs: {
                                                      id: "dimension",
                                                      name: "dimension",
                                                      "aria-labelledby":
                                                        "dimension",
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.initialMeasure =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                        _vm.handleSizeChange,
                                                      ],
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "cm" },
                                                      },
                                                      [_vm._v("cm")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "ft" },
                                                      },
                                                      [_vm._v("ft")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "w-50 d-flex" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.values.value) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-6" }, [
                          _vm.filteredProcessingValue ===
                          _vm.multiLanguage.ProductHandknotted
                            ? _c(
                                "div",
                                { staticClass: "col-12 col-md-6 mb-4" },
                                [
                                  _c(
                                    "h3",
                                    { staticClass: "h5 font-weight-bold mb-2" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.filteredProcessingValue) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.multiLanguage
                                            .ProductHandKnottedDescription
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filteredProcessingValue ===
                          _vm.multiLanguage.ProductHandwoven
                            ? _c(
                                "div",
                                { staticClass: "col-12 col-md-6 mb-4" },
                                [
                                  _c(
                                    "h3",
                                    { staticClass: "h5 font-weight-bold mb-2" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.filteredProcessingValue) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.multiLanguage
                                            .ProductHandwovenDescription
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filteredMaterialValue &&
                          _vm.filteredMaterialValue.toLowerCase() &&
                          _vm.multiLanguage.ProductWool &&
                          _vm.multiLanguage.ProductWool.toLowerCase() &&
                          _vm.filteredMaterialValue
                            .toLowerCase()
                            .includes(
                              _vm.multiLanguage.ProductWool.toLowerCase()
                            )
                            ? _c(
                                "div",
                                { staticClass: "col-12 col-md-6 mb-4" },
                                [
                                  _c(
                                    "h3",
                                    { staticClass: "h5 font-weight-bold mb-2" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.multiLanguage.ProductWoolTitle
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.multiLanguage
                                            .ProductWoolDescription
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filteredMaterialValue &&
                          _vm.filteredMaterialValue.toLowerCase() &&
                          _vm.multiLanguage.ProductSilk &&
                          _vm.multiLanguage.ProductSilk.toLowerCase() &&
                          _vm.filteredMaterialValue
                            .toLowerCase()
                            .includes(
                              _vm.multiLanguage.ProductSilk.toLowerCase()
                            )
                            ? _c(
                                "div",
                                { staticClass: "col-12 col-md-6 mb-4" },
                                [
                                  _c(
                                    "h3",
                                    { staticClass: "h5 font-weight-bold mb-2" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.multiLanguage.ProductSilkTitle
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.multiLanguage
                                            .ProductSilkDescription
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "accordion-item" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "accordion-title d-block w-100 position-relative text-left cursor-pointer py-3 collapsed",
                      attrs: {
                        id: "accordionAdvantages",
                        "data-toggle": "collapse",
                        "data-target": "#collapseAdvantages",
                        "aria-expanded": "false",
                        "aria-controls": "collapseAdvantages",
                      },
                    },
                    [
                      _c("p", { staticClass: "h4" }, [
                        _vm._v(
                          _vm._s(_vm.multiLanguage.ProductAdvantagesTitle)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapseAdvantages",
                        "aria-labelledby": "accordionAdvantages",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "py-3" },
                        [_vm._t("accordion-advantages")],
                        2
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "accordion-item" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "accordion-title d-block w-100 position-relative text-left cursor-pointer py-3 collapsed",
                      attrs: {
                        id: "accordionGurantee",
                        "data-toggle": "collapse",
                        "data-target": "#collapseGurantee",
                        "aria-expanded": "false",
                        "aria-controls": "collapseGurantee",
                      },
                    },
                    [
                      _c("p", { staticClass: "h4" }, [
                        _vm._v(_vm._s(_vm.multiLanguage.ProductGuaranteeTitle)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapseGurantee",
                        "aria-labelledby": "accordionGurantee",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "py-3" },
                        [_vm._t("accordion-guarantees")],
                        2
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "accordion-item" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "accordion-title d-block w-100 position-relative text-left cursor-pointer py-3 collapsed",
                      attrs: {
                        id: "accordionCare",
                        "data-toggle": "collapse",
                        "data-target": "#collapseCare",
                        "aria-expanded": "false",
                        "aria-controls": "collapseCare",
                      },
                    },
                    [
                      _c("p", { staticClass: "h4" }, [
                        _vm._v(_vm._s(_vm.multiLanguage.ProductCareTitle)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapseCare",
                        "aria-labelledby": "accordionCare",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "py-3" },
                        [_vm._t("accordion-care")],
                        2
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "accordion-item contact-item py-3 d-flex align-items-center justify-content-between flex-wrap",
                    staticStyle: { gap: "1rem" },
                  },
                  [_vm._t("accordion-contact")],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "lazy-hydrate",
              { attrs: { "when-idle": "" } },
              [
                _c(
                  "add-to-basket-sticky",
                  [
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-sm-items-center container-max mx-auto flex-column flex-sm-row",
                        },
                        [
                          _c("div", { staticClass: "mr-3 d-none d-md-block" }, [
                            _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src:
                                  _vm.currentVariation.images.variation.length >
                                  0
                                    ? _vm.currentVariation.images.variation[0]
                                        .urlPreview
                                    : _vm.currentVariation.images.all[0]
                                        .urlPreview,
                                alt: _vm.itemName,
                                title: _vm.itemName,
                                loading: "lazy",
                                decoding: "async",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "title-price d-flex flex-row flex-md-column align-items-center align-items-md-start justify-content-start justify-content-md-center",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "product-title overflow-hidden",
                                },
                                [_vm._v(_vm._s(_vm.itemName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "price d-flex align-items-center ml-3 ml-md-0",
                                },
                                [
                                  _c(
                                    "del",
                                    {
                                      staticClass:
                                        "total-price text-muted mr-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            (_vm.isNet
                                              ? _vm.currentVariation.prices.rrp
                                                  .data.unitPriceNet
                                              : _vm.currentVariation.prices.rrp
                                                  .data.unitPrice) +
                                              _vm.variationPropertySurcharge
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "discounted-price h5 font-weight-medium",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              (_vm.isNet
                                                ? _vm.variationGraduatedPrice
                                                    .data.unitPriceNet
                                                : _vm.variationGraduatedPrice
                                                    .data.unitPrice) +
                                                _vm.variationPropertySurcharge
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "item-advantage d-flex align-items-center",
                            },
                            [
                              _vm._t("item-availability-delivery"),
                              _vm._v(" "),
                              _vm.availability.names &&
                              _vm.availability.names.name
                                ? _c("span", [
                                    _vm._v(
                                      "\n                : " +
                                        _vm._s(_vm.availability.names.name) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "basket-button d-block d-md-flex align-items-center justify-content-center ml-0 ml-sm-3 mt-2 mt-sm-0",
                            },
                            [
                              _c("add-to-basket", {
                                attrs: {
                                  "show-buy-button": false,
                                  "variation-id":
                                    _vm.currentVariation.variation.id,
                                  "is-salable":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-children":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter
                                      .hasActiveChildren,
                                  "interval-quantity":
                                    _vm.currentVariation.variation
                                      .intervalOrderQuantity || 1,
                                  "minimum-quantity":
                                    _vm.currentVariation.variation
                                      .minimumOrderQuantity,
                                  "maximum-quantity":
                                    !!_vm.currentVariation.variation
                                      .maximumOrderQuantity &&
                                    _vm.currentVariation.variation
                                      .maximumOrderQuantity > 0
                                      ? _vm.currentVariation.variation
                                          .maximumOrderQuantity
                                      : null,
                                  "order-properties":
                                    _vm.currentVariation.properties.filter(
                                      (prop) => {
                                        return prop.property.isOderProperty
                                      }
                                    ),
                                  "has-order-properties":
                                    _vm.currentVariation.hasOrderProperties,
                                  "has-required-order-property":
                                    _vm.currentVariation
                                      .hasRequiredOrderProperty,
                                  "use-large-scale": false,
                                  "show-quantity": true,
                                  "item-url": _vm._f("itemURL")(
                                    _vm.currentVariation
                                  ),
                                  "is-variation-selected":
                                    _vm.isVariationSelected &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-price": _vm._f("hasItemDefaultPrice")(
                                    _vm.currentVariation
                                  ),
                                  "multi-language": {
                                    ProductBuyNow:
                                      _vm.multiLanguage.ProductBuyNow,
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }